import type { OfferStatus } from "@/libs/generated/types";

import { OfferStatus as OfferStatusEnum } from "@/types/models/offer.types";

function getOfferColorByStatus(status: OfferStatus): "success" | "error" | "warning" | "info" {
  switch (status) {
    case OfferStatusEnum.ACCEPTED:
      return "success";
    case OfferStatusEnum.REJECTED:
      return "error";
    case OfferStatusEnum.PENDING:
      return "warning";
    default:
      return "info";
  }
}

export { getOfferColorByStatus };
